import type { AnyObject } from 'react-final-form';

export const customEvent = ({ tag, data = {} }: { tag: string; data?: AnyObject }) => {
  let customEvent: CustomEvent;
  if (typeof CustomEvent === 'function') {
    customEvent = new CustomEvent(tag, {
      bubbles: true,
      cancelable: true,
      detail: data
    });
    document.dispatchEvent(customEvent);
  } else {
    customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(tag, true, true, data);
    document.dispatchEvent(customEvent);
  }
};
